export abstract class EventHelper {
  public static emitEvent(eventName: string, details?: object): void {
    const event = new CustomEvent(eventName, { detail: details });

    document.dispatchEvent(event);
  }
}
